/* RESPONSIBLE TEAM: team-knowledge-foundations */

export enum SortableFields {
  SuggestedAt = 'content_review_request_created_at',
  Priority = 'priority',
}

export type SortDirection = 'asc' | 'desc';

export const enum ProjectedConversationsRanking {
  Low = 0,
  Medium = 1,
  High = 2,
}
